import React from "react";
import calenderIcon from "../../assets/CalendarDots.png";
import dateFormat from "dateformat";
import {
  formatAmountWithSymbol,
  getStatusColor,
  reduceLongName,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import Tippy from "@tippyjs/react";
import { QUEUE_ORDER_STATUS } from "../../appConstants";
import { useSelector } from "react-redux";
export default function RequestDetailsCard({
  request,
  selectedRequest,
  handleClick,
}) {
  const user = useSelector((state) => state.user.user);
  return (
    <div
      onClick={() => {
        handleClick(request);
      }}
      className={`
        cursor-pointer
         transition-all duration-200 ease-in-out transform 
    ${
      selectedRequest?.id === request.id
        ? "border-[4px] border-l-[#0F5EFF]"
        : ""
    } w-full min-h-[80px] border-t-[1px] border-b-[1px]  border-t-[#D9D9D9] border-b-[#D9D9D9]`}
    >
      <div className="py-[0.8rem]  pl-6 pr-5 flex flex-col gap-[2px] text-[14px]">
        <div className="w-full flex justify-between">
          <span className="text-[14px] font-[700] text-[#1E1E1E] font-manrope ">
            {request?.user_name || "-"}
          </span>
          <div className="min-w-[75px] text-[12px] gap-[4px] justify-center px-1 py-1 flex items-center bg-[#D9D9D9] rounded-[20px]">
            <img src={calenderIcon} alt="request-date" />
            <span className="mt-[1px]">
              {dateFormat(request?.date_created, "dd mmm")}
            </span>
          </div>
        </div>
        <div className="flex gap-[2px] items-center">
          <span>Req No.</span>
          <span className="text-[#1E1E1E] text-[15px] font-[700] font-manrope ">
            #{request?.req_number}
          </span>
        </div>
        <Tippy content={request?.field_address}>
          <span className="font-[400] text-[15px] text-[#3B3B3B] font-manrope ">
            {reduceLongName(request?.field_address || "-", 80)}
          </span>
        </Tippy>
        <div className="flex w-full justify-between items-center">
          <div className="flex gap-1 text-[16px] font-manrope items-center font-[500]">
            <span className="text-[15px] text-[500] text-[#1E1E1E]">
              {request?.price_by === "acre"
                ? squareKilometersToAcres(request?.field_area)
                : request?.field_area}{" "}
              Acre
            </span>
            {request?.total_amount && (
              <>
                <div className="h-[15px]  ml-[2px] mr-[2px]  border border-[#BFC8D9]"></div>
                <span>
                  {/* {formatAmountWithSymbol(request?.total_amount, user?.country_code)} */}
                  {formatAmountWithSymbol(
                    request?.total_amount,
                    user?.country_code,
                    user?.dsp?.invoice_currency,
                  )}
                </span>
              </>
            )}
          </div>
          <div
            style={{
              color: getStatusColor(request?.status, true),
            }}
            className={`font-[700] text-[15px]`}
          >
            {request?.status === QUEUE_ORDER_STATUS.NOACTION
              ? "Placed"
              : request?.status === QUEUE_ORDER_STATUS.EXPIRED
                ? "Not Available"
                : request?.status === QUEUE_ORDER_STATUS.OTHERDSP
                  ? "Missed"
                  : request?.status === QUEUE_ORDER_STATUS.REJECTED
                    ? "Rejected"
                    : request?.status ===
                          QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS ||
                        request?.status === QUEUE_ORDER_STATUS.MISSEDBYFARMER ||
                        request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER
                      ? "Cancelled"
                      : request?.status}
          </div>
        </div>
      </div>
    </div>
  );
}
